import { render, staticRenderFns } from "./subScoreScaleDeveloped.vue?vue&type=template&id=ca445154&scoped=true"
import script from "./subScoreScaleDeveloped.vue?vue&type=script&lang=js"
export * from "./subScoreScaleDeveloped.vue?vue&type=script&lang=js"
import style0 from "./subScoreScaleDeveloped.vue?vue&type=style&index=0&id=ca445154&prod&lang=scss&scoped=true"
import style1 from "./subScoreScaleDeveloped.vue?vue&type=style&index=1&id=ca445154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca445154",
  null
  
)

export default component.exports